// tslint:disable
import { ArticleEstimation, isSameMonth, ItemEstimation, MonthEstimation } from '../../../domain/estimations/Estimations';
import EstimationState from '../State';
import EstimationChangeConfirmed from '../events/EstimationChangeConfirmed';
import { Month } from '../../../view/admin/getEstimationMonths';
import calculatePrice from '../../../domain/calculatePrice';

export default (state: EstimationState, event: EstimationChangeConfirmed): EstimationState => ({
    ...state,
    estimations: estimationToUpdate(state.estimations, event.month)
        .reduce(
            (estimations: MonthEstimation[], estimationToUpdate: MonthEstimation): MonthEstimation[] => [
                ...estimations,
                {
                    ...estimationToUpdate,
                    articlesEstimations: articlesToUpdate(estimationToUpdate.articlesEstimations, event.product.articleId).reduce(
                        (d: ArticleEstimation[], articleEstimation: ArticleEstimation): ArticleEstimation[] => [
                            ...d,
                            {
                                ...articleEstimation,
                                wholesalePrice: event.product.wholesalePrice,
                                discountedPrice: calculatePrice(
                                    event.product.wholesalePrice,
                                    event.discountRate,
                                    event.product.discountCodeASet
                                ),
                                itemsEstimations: [...itemsNotToUpdate(articleEstimation.itemsEstimations, event.sku), createItem(event)]
                            }
                        ],
                        [
                            ...articlesNotToUpdate(estimationToUpdate.articlesEstimations, event.product.articleId),
                            ...newArticles(estimationToUpdate.articlesEstimations, event)
                        ]
                    )
                }
            ],
            [...estimationsNotToUpdate(state.estimations, event.month), ...newEstimation(state.estimations, event)]
        )
        .map(filterOutEmptyEstimation)
});

const filterOutEmptyEstimation = (a: MonthEstimation) => ({
    ...a,
    articlesEstimations: a.articlesEstimations
        .map((b: ArticleEstimation) => {
            return {
                ...b,
                itemsEstimations: b.itemsEstimations.filter((i: ItemEstimation) => i.value > 0)
            };
        })
        .filter((b: ArticleEstimation) => b.itemsEstimations.length > 0)
});

const itemsNotToUpdate = (a: ItemEstimation[], sku: string): ItemEstimation[] => a.filter((c: ItemEstimation) => c.sku !== sku);

const articlesNotToUpdate = (a: ArticleEstimation[], articleId: string): ArticleEstimation[] =>
    a.filter((c: ArticleEstimation) => c.articleId !== articleId);

const newArticles = (e: ArticleEstimation[], event: EstimationChangeConfirmed): ArticleEstimation[] =>
    e.find((b: ArticleEstimation) => b.articleId === event.product.articleId) === undefined ? [createArticle(event)] : [];

const articlesToUpdate = (a: ArticleEstimation[], articleId: string): ArticleEstimation[] =>
    a.filter((c: ArticleEstimation) => c.articleId === articleId);

const estimationToUpdate = (a: MonthEstimation[], m: Month): MonthEstimation[] => a.filter((c: MonthEstimation) => isSameMonth(c.month, m));

const estimationsNotToUpdate = (a: MonthEstimation[], m: Month): MonthEstimation[] =>
    a.filter((c: MonthEstimation) => !isSameMonth(c.month, m));

const newEstimation = (e: MonthEstimation[], event: EstimationChangeConfirmed): MonthEstimation[] =>
    e.filter((b: MonthEstimation) => isSameMonth(b.month, event.month)).length !== 0
        ? []
        : [
              {
                  id: '',
                  month: event.month,
                  articlesEstimations: [createArticle(event)]
              }
          ];

const createArticle = (event: EstimationChangeConfirmed): ArticleEstimation => ({
    articleId: event.product.articleId,
    wholesalePrice: event.product.wholesalePrice,
    discountedPrice: calculatePrice(event.product.wholesalePrice, event.discountRate, event.product.discountCodeASet),
    itemsEstimations: [createItem(event)]
});

const createItem = (event: EstimationChangeConfirmed): ItemEstimation => ({
    sku: event.sku,
    value: event.value,
    variantCode: event.variantCode
});



// WEBPACK FOOTER //
// ./src/application/estimations/reducer/estimationChangeConfirmed.ts